import styled from 'styled-components';

const DropdownList = styled.div`
  background-color: #fff;
  padding: 20px 0;
  white-space: nowrap;
  overflow-y: auto;
  box-shadow: 0 3px 7px rgba(0, 0, 0, 0.45), 0 2px 2px rgba(0, 0, 0, 0.45);
  max-height: calc(100vh - 30px - 40px);
`;

export default DropdownList;
